import { render, staticRenderFns } from "./VisitorQandA.vue?vue&type=template&id=458e23ba&scoped=true"
import script from "./VisitorQandA.vue?vue&type=script&lang=js"
export * from "./VisitorQandA.vue?vue&type=script&lang=js"
import style0 from "./VisitorQandA.vue?vue&type=style&index=0&id=458e23ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458e23ba",
  null
  
)

export default component.exports